
import { createNamespacedHelpers } from 'vuex'
import { gbLocalStorage } from '~/utils/helpers'

const { mapState } = createNamespacedHelpers('education')
export default {
  name: 'ProgramsList',
  data() {
    return {
      i18n: 'pages.education.courses-list',
      selectedTrajectory: '',
      selectedBookmarkTab: '',
      isHideCompleted: false,
      // old
      initialBookmarkTab: null,
      selectedBlockId: 0,
      isBlockLoading: false,
      selectedBlocksInBookmarkTabs: {},
      selectedBlocksInTrajectory: {}
    }
  },

  computed: {
    ...mapState([
      'notifications',
      'specializationsList',
      'newTrajectories',
      'newBlocks'
    ]),

    isTrajectoryCardsSelector() {
      return (
        this.newTrajectories && Object.keys(this.newTrajectories).length > 1
      )
    },

    isTesting() {
      return this.$route.hash === '#test'
    },

    bookmarkTabs() {
      return [
        {
          label: this.$t(`${this.i18n}.bookmark-tabs.main`),
          value: 'main',
          icon: 'PlaySpeedOutline28',
          counter: { value: this.totalNotifications.mainTotal || null }
        },
        {
          label: this.$t(`${this.i18n}.bookmark-tabs.additional`),
          value: 'additional',
          icon: 'PlayCards2Outline28',
          counter: { value: this.totalNotifications.additionalTotal || null }
        }
      ]
    },

    filteredBlocks() {
      return Object.values(this.newBlocks)
        .filter(block => {
          if (
            this.isMainBookmarkTab &&
            this.newTrajectories &&
            this.isTesting
          ) {
            return (
              block?.blockType === 'main' &&
              (+block.trajectoryId === +this.selectedTrajectory ||
                (block.trajectoryId === null &&
                  this.selectedTrajectory === 'others'))
            )
          }

          return (
            block?.blockType === this.selectedBookmarkTab &&
            // Ограничение для слотов в рамках теста на проде в случае если нет траектории
            block.type !== 'slot'
          )
        })
        ?.sort((a, b) => a.trajectoryProductId - b.trajectoryProductId)
    },

    firstBlock() {
      return this.filteredBlocks?.[0]
    },

    selectedBlock() {
      return this.newBlocks?.[this.selectedBlockId] || {}
    },

    blockTabs() {
      return this.filteredBlocks.map(block => {
        const id = this.handleGetBlockId(block)

        return {
          id,
          completed: block.completed,
          title: block.title || block.trajectoryProductTitle,
          isNotices: this.checkIsBlockNotice(id)
        }
      })
    },

    totalNotifications() {
      let mainTotal = 0
      let additionalTotal = 0

      for (const block of Object.values(this.notifications)) {
        const blockTotal =
          Object.keys(block.courses).length + block.blockNotificationsIds.length

        if (block.type === 'main') {
          mainTotal += blockTotal
        } else {
          additionalTotal += blockTotal
        }
      }

      return { mainTotal, additionalTotal }
    },

    isMainBookmarkTab() {
      return this.selectedBookmarkTab === 'main'
    },

    isBlocks() {
      return this.filteredBlocks?.length
    },

    isTabsInBlock() {
      return !!this.selectedBlock?.tabs?.length
    }
  },

  watch: {
    selectedTrajectory(trajectory, oldValue) {
      this.$store.commit('education/resetSpecializationsList')

      if (oldValue) {
        const idForSelect =
          this.selectedBlocksInTrajectory[trajectory] ||
          this.handleGetBlockId(this.firstBlock)

        if (idForSelect) {
          this.selectBlock(idForSelect)
        }
      }
    },

    selectedBookmarkTab(tab, oldValue) {
      if (oldValue) {
        const idForSelect =
          this.selectedBlocksInBookmarkTabs[tab] ||
          this.handleGetBlockId(this.firstBlock)

        if (idForSelect) {
          this.selectBlock(idForSelect)
        }
      }
    },

    selectedBlockId(id) {
      gbLocalStorage.set('education-selected-block-id', id)
      this.saveSelectedBlockForCurrentTab(this.selectedBookmarkTab)
      this.saveSelectedBlockForCurrentTrajectory(this.selectedTrajectory)
      this.handleBlockFetching(id)
      this.readBlockNotification(id)
    },

    isHideCompleted() {
      if (this.isHideCompleted) {
        gbLocalStorage.set('education-hide-completed', true)
      } else {
        gbLocalStorage.remove('education-hide-completed')
      }
    }
  },

  updated() {
    this.mobileScrollToTrajectoryCard()
  },

  beforeMount() {
    window.addEventListener(
      'education-set-block-after-slot',
      this.handleEventSelectBlock
    )

    this.setInitialData()
  },

  beforeDestroy() {
    window.removeEventListener(
      'education-set-block-after-slot',
      this.handleEventSelectBlock
    )
  },

  methods: {
    selectBlock(id) {
      if (id) {
        this.selectedBlockId = id
      }
    },

    handleBlockFetching(id) {
      const isSelectedBlockSlot = this.selectedBlock?.type === 'slot'
      if (!isSelectedBlockSlot && !this.isTabsInBlock) {
        this.fetchBlockData(id)
      } else if (
        isSelectedBlockSlot &&
        !Object.keys(this.specializationsList)?.length
      ) {
        this.$store.dispatch(
          'education/fetchSpecializationsList',
          this.selectedBlock.trajectoryId
        )
      }
    },

    async fetchBlockData(id) {
      this.isBlockLoading = true
      this.$store.dispatch(
        'education/fetchBlockProgressItems',
        id === 'separate' ? null : id
      )
      await this.$store.dispatch(
        'education/fetchBlockData',
        id === 'separate' ? null : id
      )
      this.isBlockLoading = false
    },

    readBlockNotification(blockId) {
      if (this.notifications?.[blockId]?.blockNotificationsIds?.length) {
        this.notifications[blockId].blockNotificationsIds.forEach(async id => {
          const response = await this.$store.dispatch(
            'education/removeNotice',
            id
          )

          if (response === 'ok') {
            this.$store.commit('education/deleteNotificationBlock', blockId)
          }
        })
      }
    },

    checkIsBlockNotice(id) {
      const noticeBlock = this.notifications[id]

      return (
        noticeBlock &&
        (noticeBlock.blockNotificationsIds?.length ||
          Object.keys(noticeBlock.courses).length)
      )
    },

    selectBookmarkTab(tab) {
      if (tab) {
        gbLocalStorage.set('education-bookmark-tab', tab)
        this.selectedBookmarkTab = tab
      }
    },

    handleEventSelectBlock(event) {
      this.selectBlock(event.detail?.id)
    },

    handleGetBlockId(block) {
      if (!block) {
        return
      }

      return (
        block.productAttendeeId ||
        block.trajectoryKey ||
        block.trajectoryProductId ||
        block.type
      )
    },

    refreshTab() {
      this.selectedBlockId = +this.selectedBlockId
    },

    saveSelectedBlockForCurrentTab(tab) {
      this.selectedBlocksInBookmarkTabs[tab] = this.selectedBlockId
    },

    saveSelectedBlockForCurrentTrajectory(trajectoryName) {
      this.selectedBlocksInTrajectory[trajectoryName] = this.selectedBlockId
    },

    mobileScrollToTrajectoryCard() {
      if (this.newTrajectories && window.innerWidth < 768) {
        const selectedTrajectoryElem = document.querySelector(
          '#education-selected-trajectory'
        )

        if (selectedTrajectoryElem) {
          selectedTrajectoryElem.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          })
        }
      }
    },

    getInitialDataFromStorage() {
      const storageSelectedBlockId = gbLocalStorage.get(
        'education-selected-block-id'
      )
      const storageSelectedBookmarkTab = gbLocalStorage.get(
        'education-bookmark-tab'
      )
      const storageSelectedTrajectory = gbLocalStorage.get(
        'education-trajectory'
      )
      const isHideCompleted = gbLocalStorage.get('education-hide-completed')

      return {
        storageSelectedBlockId,
        storageSelectedBookmarkTab,
        storageSelectedTrajectory,
        isHideCompleted
      }
    },

    setInitialData() {
      const {
        storageSelectedBlockId,
        storageSelectedBookmarkTab,
        storageSelectedTrajectory,
        isHideCompleted
      } = this.getInitialDataFromStorage()

      this.isHideCompleted = isHideCompleted || false

      this.initialBookmarkTab = +(storageSelectedBookmarkTab === 'additional')

      if (this.newTrajectories) {
        this.selectedTrajectory = Object.keys(this.newTrajectories)
          .map(k => String(k))
          .includes(storageSelectedTrajectory)
          ? storageSelectedTrajectory
          : Object.entries(this.newTrajectories)?.[0]?.[0]
      }

      this.selectedBookmarkTab = this.initialBookmarkTab ? 'additional' : 'main'

      if (
        storageSelectedBlockId &&
        this.newBlocks[storageSelectedBlockId]?.blockType ===
          storageSelectedBookmarkTab
      ) {
        this.selectBlock(storageSelectedBlockId)
      } else {
        this.selectBlock(
          this.firstBlock?.productAttendeeId ||
            this.firstBlock?.trajectoryProductId
        )
      }
    }
  }
}
